import { Box, type SxProps, useColorScheme } from '@mui/material';
import { memo } from 'react';
import { cdnStaticPath } from '@/helpers/url';

const sxProps: SxProps = {
  objectFit: 'cover',
  objectPosition: '1.5px center',
};

export const Logo = memo(function Logo(props: { width?: number | 'auto'; height?: number } | { size: number }) {
  const { colorScheme } = useColorScheme();
  const sizingProps =
    'size' in props
      ? { width: props.size, height: props.size, sx: sxProps }
      : { width: props.width ?? '100%', height: props.height ?? '100%' };

  return (
    <Box
      component="img"
      src={cdnStaticPath(`static/images/qdrant-logo${colorScheme === 'dark' ? '-dark' : ''}.svg`)}
      alt="logo"
      {...sizingProps}
    />
  );
});

export const LogoIcon = ({ size }: { size: number }) => <Logo size={size} />;
